import {  CommonModule  } from '@angular/common';
import {  Component     ,
          Input         } from '@angular/core';
import {  TranslatePipe } from 'nv@services/translate.service';

@Component({
  selector    : 'template-pricing-details',
  templateUrl : './template-pricing-details.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplatePricingDetails {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
